console.log('capacity-drawer-ui loaded');

(function () {
  'use strict';

  // ── Constants ─────────────────────────────────────────────────
  var BUNDLE_VARIANT_ID     = 52875861131573;
  var BUNDLE_SELLING_PLAN   = 710753616181;
  var BUNDLE_PRICE_SUB      = 9900;   // $99
  var BUNDLE_PRICE_OTP      = 13400;  // $134

  var CREATINE_VARIANT_ID   = 52820531544373;
  var CREATINE_SELLING_PLAN = 710753747253;
  var CREATINE_PRICE_SUB    = 5500;   // $55 (summer sale sub)
  var CREATINE_PRICE_OTP    = 6500;   // $65 (summer sale otp)
  var CREATINE_BASE_SUB     = 6900;   // $69 (base sub before sale)
  var CREATINE_BASE_OTP     = 7900;   // $79 (base otp before sale)

  var PURE_CREATINE_VARIANT_ID   = 52988037693749;
  var PURE_CREATINE_SELLING_PLAN = 710830096693;
  var PURE_CREATINE_PRICE_SUB    = 5000;   // $50 (summer sale sub)
  var PURE_CREATINE_PRICE_OTP    = 6500;   // $65 (summer sale otp)
  var PURE_CREATINE_BASE_SUB     = 6900;   // $69 (base sub before sale)
  var PURE_CREATINE_BASE_OTP     = 7900;   // $79 (base otp before sale)

  // ── State ─────────────────────────────────────────────────────
  var currentCart    = null;
  var itemsObserver  = null;
  var dialogObserver = null;
  var reconnectTimer = null;
  var observerTarget = null;

  // ── Helpers ───────────────────────────────────────────────────

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function fmt(cents) {
    var n = cents / 100;
    return '$' + (n % 1 === 0 ? n : n.toFixed(2));
  }

  function savePct(sub, otp) {
    return 'SAVE ' + Math.round((otp - sub) / otp * 100) + '%';
  }

  function findItem(cart, vid) {
    if (!cart || !cart.items) return null;
    return cart.items.find(function (i) { return Number(i.variant_id) === Number(vid); }) || null;
  }

  function isSub(item) { return !!(item && item.selling_plan_allocation); }

  function rm(scope, key) {
    var el = scope.querySelector('[data-ch-drawer="' + key + '"]');
    if (el) el.remove();
  }

  function mk(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text !== undefined) e.textContent = text;
    return e;
  }

  // ── 1. Count badge ────────────────────────────────────────────

  function injectCountBadge(cart, scope) {
    var heading = scope.querySelector('.cart-drawer__heading');
    if (!heading) return;
    rm(scope, 'count');
    if (!cart || !cart.item_count) return;
    var badge = mk('span', 'ch-d-count-badge', cart.item_count);
    badge.setAttribute('data-ch-drawer', 'count');
    heading.appendChild(badge);
  }

  // ── 2. Item card (replaces the entire Horizon table row) ──────

  function injectItemCard(item, isSubActive, priceSub, priceOtp, baseSub, baseOtp, savings, sellingPlan, variantId, isBundle, scope) {
    rm(scope, 'item-card');

    var container = scope.querySelector('.cart-drawer__items');
    if (!container) return;

    var card = mk('div', 'ch-d-item-card');
    card.setAttribute('data-ch-drawer', 'item-card');

    // — Eyebrow ——————————————————————————————————
    var eyebrow = mk('div', 'ch-d-eyebrow');
    eyebrow.appendChild(mk('span', 'ch-d-eyebrow__star', '★'));
    eyebrow.appendChild(mk('span', 'ch-d-eyebrow__text', '4.5+ Stars · Most Popular'));
    card.appendChild(eyebrow);

    // — Product row ——————————————————————————————
    var productRow = mk('div', 'ch-d-product-row');

    var imgUrl = (item.featured_image && item.featured_image.url) ? item.featured_image.url : item.image;
    if (imgUrl) {
      var img = document.createElement('img');
      img.className = 'ch-d-product-img';
      img.src = imgUrl;
      img.alt = item.product_title || '';
      img.width = 64;
      img.height = 64;
      productRow.appendChild(img);
    }

    var qty = item.quantity;
    var key = item.key;

    var info = mk('div', 'ch-d-product-info');
    info.appendChild(mk('p', 'ch-d-product-name', item.product_title || item.title || ''));

    var subtitle = isSubActive ? 'Subscribe · 4-week delivery' : 'One-time purchase';
    info.appendChild(mk('p', 'ch-d-product-subtitle', subtitle));

    // Price LEFT + quantity controls RIGHT on the same row
    var priceWrap = mk('div', 'ch-d-price-row');

    var priceLeft = mk('div', 'ch-d-price-left');
    priceLeft.appendChild(mk('span', 'ch-d-price__current', fmt(isSubActive ? priceSub : priceOtp)));
    if (isSubActive) {
      priceLeft.appendChild(mk('span', 'ch-d-price__was', fmt(baseSub)));
      priceLeft.appendChild(mk('span', 'ch-d-save-pill', savePct(priceSub, baseSub)));
    } else {
      priceLeft.appendChild(mk('span', 'ch-d-price__was', fmt(baseOtp)));
      priceLeft.appendChild(mk('span', 'ch-d-save-pill', savePct(priceOtp, baseOtp)));
    }
    priceWrap.appendChild(priceLeft);

    var qtyWrap = mk('div', 'ch-d-qty');
    var minBtn  = mk('button', 'ch-d-qty__btn', '−');
    minBtn.type = 'button';
    minBtn.addEventListener('click', function () { if (qty > 1) handleQtyChange(key, qty - 1); });
    var qtyNum  = mk('span', 'ch-d-qty__num', qty);
    var plusBtn = mk('button', 'ch-d-qty__btn', '+');
    plusBtn.type = 'button';
    plusBtn.addEventListener('click', function () { handleQtyChange(key, qty + 1); });
    qtyWrap.appendChild(minBtn);
    qtyWrap.appendChild(qtyNum);
    qtyWrap.appendChild(plusBtn);
    priceWrap.appendChild(qtyWrap);

    info.appendChild(priceWrap);

    productRow.appendChild(info);
    card.appendChild(productRow);

    // — Delivery / upsell callout pill ——————————
    var callout = mk('div');
    if (isSubActive) {
      callout.className = 'ch-d-callout ch-d-callout--sub';
      callout.textContent = '↻ Delivered every 4 weeks · Cancel anytime';
    } else {
      callout.className = 'ch-d-callout ch-d-callout--otp';
      callout.textContent = '↓ Subscribe instead — save ' + fmt(savings) + '/mo · $' + (savings / 100 * 12) + '/yr';
    }
    card.appendChild(callout);

    // — Toggle row (full width, no quantity) —————
    var toggleRow = mk('div', 'ch-d-toggle-row');

    var otpLabel = mk('span', 'ch-d-toggle__label' + (!isSubActive ? ' is-active' : ''), 'One-Time');

    var track = mk('div', 'ch-d-toggle__track' + (isSubActive ? ' is-sub' : ''));
    var dot   = mk('div', 'ch-d-toggle__dot');
    track.appendChild(dot);

    var subLabel = mk('span', 'ch-d-toggle__label' + (isSubActive ? ' is-active' : ''), 'Subscribe & Save');

    function doToggle() {
      toggleRow.classList.add('ch-d-toggle-qty--loading');
      handleToggle(!isSubActive, variantId, sellingPlan);
    }

    otpLabel.addEventListener('click', function () { if (isSubActive) doToggle(); });
    track.addEventListener('click', doToggle);
    subLabel.addEventListener('click', function () { if (!isSubActive) doToggle(); });

    toggleRow.appendChild(otpLabel);
    toggleRow.appendChild(track);
    toggleRow.appendChild(subLabel);
    card.appendChild(toggleRow);

    // — Bundle contents card (bundle only) ————————
    if (isBundle) {
      var bundleCard = mk('div', 'ch-d-bundle-card');
      [
        ['✓ Creatine Hydration Mix',    'INCLUDED'],
        ['⚡ Superhuman Energy Strips',  '$40 VALUE'],
      ].forEach(function (pair) {
        var rowEl = mk('div', 'ch-d-bundle-card__row');
        rowEl.appendChild(mk('span', 'ch-d-bundle-card__item', pair[0]));
        rowEl.appendChild(mk('span', 'ch-d-bundle-card__badge', pair[1]));
        bundleCard.appendChild(rowEl);
      });
      card.appendChild(bundleCard);
    }

    container.appendChild(card);
  }

  // ── 3. Order summary ─────────────────────────────────────────

  function addSummaryRow(parent, label, value, mod) {
    var row = mk('div', 'ch-d-summary__row' + (mod ? ' ch-d-summary__' + mod : ''));
    row.appendChild(mk('span', null, label));
    row.appendChild(mk('span', null, value));
    parent.appendChild(row);
  }

  function injectOrderSummary(isSubActive, priceSub, priceOtp, baseSub, baseOtp, scope) {
    rm(scope, 'order-summary');
    var anchor = scope.querySelector('.cart-totals');
    if (!anchor) return;

    var wrap = mk('div', 'ch-d-summary');
    wrap.setAttribute('data-ch-drawer', 'order-summary');

    if (isSubActive) {
      addSummaryRow(wrap, 'Subtotal', fmt(baseSub), '');
      addSummaryRow(wrap, 'Subscription savings', '−' + fmt(baseSub - priceSub), 'savings');
    } else {
      addSummaryRow(wrap, 'Subtotal', fmt(baseOtp), '');
      addSummaryRow(wrap, 'Summer Sale savings', '−' + fmt(baseOtp - priceOtp), 'savings');
    }
    var shipLabel = isSubActive ? '✓ Free shipping' : '✓ Free shipping included';
    addSummaryRow(wrap, shipLabel, '$0.00', 'shipping');
    addSummaryRow(wrap, 'Estimated total', 'Calculated at checkout', 'total');

    anchor.insertAdjacentElement('beforebegin', wrap);
  }

  // ── 4. Trust strip ────────────────────────────────────────────

  function injectTrustStrip(scope) {
    rm(scope, 'trust');
    var ctas = scope.querySelector('.cart__ctas');
    if (!ctas) return;

    var strip = mk('div', 'ch-d-trust');
    strip.setAttribute('data-ch-drawer', 'trust');

    [
      ['↻', 'Cancel Anytime'],
      ['🛡', '30-Day Guarantee'],
      ['🚚', 'Free Shipping'],
    ].forEach(function (pair) {
      var item = mk('div', 'ch-d-trust__item');
      item.appendChild(mk('span', 'ch-d-trust__icon', pair[0]));
      item.appendChild(mk('span', 'ch-d-trust__label', pair[1]));
      strip.appendChild(item);
    });

    var btn = ctas.querySelector('#checkout, .cart__checkout-button');
    if (btn) {
      ctas.insertBefore(strip, btn);
    } else {
      ctas.appendChild(strip);
    }
  }

  // ── 5. Review card ────────────────────────────────────────────

  function injectReviewCard(scope) {
    var ctas = scope.querySelector('.cart__ctas');
    if (!ctas) return;
    var existing = ctas.querySelector('.ch-drawer-review');
    if (existing) existing.remove();
    var card = document.createElement('div');
    card.className = 'ch-drawer-review';
    card.innerHTML = '<div class="ch-drawer-review__stars">\u2605\u2605\u2605\u2605\u2605</div><p class="ch-drawer-review__quote">\u201cI was one of the first people to try this and I\u2019d be the first to call it out if it wasn\u2019t worth it. It is. Clean formulas and a brand that\u2019s genuine. The kind of thing you recommend to people you actually care about.\u201d</p><div class="ch-drawer-review__footer"><div><span class="ch-drawer-review__name">Chris R.</span><span class="ch-drawer-review__meta">Alias used for Privacy</span></div><span class="ch-drawer-review__verified">\u2713 VERIFIED</span></div>';
    ctas.appendChild(card);
  }

  // ── 6. Checkout button ────────────────────────────────────────

  function enhanceCheckoutBtn(scope) {
    var btn = scope.querySelector('#checkout, .cart__checkout-button');
    if (!btn || btn.hasAttribute('data-ch-drawer')) return;
    btn.setAttribute('data-ch-drawer', 'checkout');
    btn.classList.add('ch-d-checkout');
    var textEl = btn.querySelector('.button-text');
    if (textEl) textEl.textContent = '🔒 Secure Checkout →';
  }

  // ── Product config resolver ───────────────────────────────────
  // Returns the pricing / selling-plan config for a cart line item.
  // Known products use their exact sale + strikethrough prices; any other
  // product falls back to values derived from the Shopify cart line item so
  // the drawer renders dynamically for ANY product, not just hardcoded ones.

  function buildGenericConfig(item) {
    var alloc = item.selling_plan_allocation;
    var sellingPlan = (alloc && alloc.selling_plan && alloc.selling_plan.id) || null;

    var priceSub, priceOtp;
    if (alloc) {
      // Subscribed line: allocation carries both the sub price and the OTP compare price.
      priceSub = alloc.price;
      priceOtp = (alloc.compare_at_price != null ? alloc.compare_at_price : (item.original_price || item.price));
    } else {
      // One-time line: only the OTP price is known.
      priceOtp = item.price;
      priceSub = item.price;
    }

    var base = item.original_price || priceOtp;
    return {
      isBundle: false,
      priceSub: priceSub,
      priceOtp: priceOtp,
      baseSub: base,
      baseOtp: base,
      sellingPlan: sellingPlan,
      variantId: item.variant_id
    };
  }

  function getProductConfig(item) {
    switch (Number(item.variant_id)) {
      case BUNDLE_VARIANT_ID:
        return {
          isBundle: true,
          priceSub: BUNDLE_PRICE_SUB, priceOtp: BUNDLE_PRICE_OTP,
          baseSub: BUNDLE_PRICE_OTP, baseOtp: BUNDLE_PRICE_OTP,
          sellingPlan: BUNDLE_SELLING_PLAN, variantId: BUNDLE_VARIANT_ID
        };
      case CREATINE_VARIANT_ID:
        return {
          isBundle: false,
          priceSub: CREATINE_PRICE_SUB, priceOtp: CREATINE_PRICE_OTP,
          baseSub: CREATINE_BASE_SUB, baseOtp: CREATINE_BASE_OTP,
          sellingPlan: CREATINE_SELLING_PLAN, variantId: CREATINE_VARIANT_ID
        };
      case PURE_CREATINE_VARIANT_ID:
        return {
          isBundle: false,
          priceSub: PURE_CREATINE_PRICE_SUB, priceOtp: PURE_CREATINE_PRICE_OTP,
          baseSub: PURE_CREATINE_BASE_SUB, baseOtp: PURE_CREATINE_BASE_OTP,
          sellingPlan: PURE_CREATINE_SELLING_PLAN, variantId: PURE_CREATINE_VARIANT_ID
        };
      default:
        return buildGenericConfig(item);
    }
  }

  // ── Master render ─────────────────────────────────────────────

  function renderAll(cart) {
    var scope = document.querySelector('cart-drawer-component');
    if (!scope || !cart || cart.item_count === 0) return;

    // Prefer a known product if present, otherwise render whatever is in the cart.
    var active = findItem(cart, BUNDLE_VARIANT_ID)
              || findItem(cart, CREATINE_VARIANT_ID)
              || findItem(cart, PURE_CREATINE_VARIANT_ID)
              || (cart.items && cart.items[0]);
    if (!active) return;

    var cfg         = getProductConfig(active);
    var isBundle    = cfg.isBundle;
    var priceSub    = cfg.priceSub;
    var priceOtp    = cfg.priceOtp;
    var baseSub     = cfg.baseSub;
    var baseOtp     = cfg.baseOtp;
    var savings     = priceOtp - priceSub;
    var sellingPlan = cfg.sellingPlan;
    var variantId   = cfg.variantId;
    var isSubActive = isSub(active);

    pauseObserver();
    try {
      injectCountBadge(cart, scope);
      injectItemCard(active, isSubActive, priceSub, priceOtp, baseSub, baseOtp, savings, sellingPlan, variantId, isBundle, scope);
      injectOrderSummary(isSubActive, priceSub, priceOtp, baseSub, baseOtp, scope);
      injectTrustStrip(scope);
      enhanceCheckoutBtn(scope);
      injectReviewCard(scope);
    } catch (e) {
      console.error('[capacityDrawerUI]', e);
    }
    resumeObserver();
  }

  // ── Observer management ───────────────────────────────────────

  function pauseObserver() {
    if (itemsObserver) itemsObserver.disconnect();
    clearTimeout(reconnectTimer);
  }

  function resumeObserver() {
    clearTimeout(reconnectTimer);
    reconnectTimer = setTimeout(function () {
      if (observerTarget && itemsObserver) {
        itemsObserver.observe(observerTarget, { childList: true, subtree: true });
      }
    }, 200);
  }

  function setupObserver() {
    observerTarget = document.querySelector('.cart-drawer__inner');
    if (!observerTarget) {
      console.log('[capacityDrawerUI] .cart-drawer__inner not found');
      return;
    }

    var debounceTimer = null;
    itemsObserver = new MutationObserver(function () {
      console.log('observer fired');
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        fetchCart().then(function (cart) {
          currentCart = cart;
          renderAll(cart);
        });
      }, 80);
    });
    itemsObserver.observe(observerTarget, { childList: true, subtree: true });

    var dialog = document.querySelector('.cart-drawer__dialog');
    if (dialog) {
      dialogObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.attributeName === 'open' && dialog.hasAttribute('open')) {
            console.log('observer fired (dialog open)');
            fetchCart().then(function (cart) {
              currentCart = cart;
              renderAll(cart);
            });
          }
        });
      });
      dialogObserver.observe(dialog, { attributes: true });
    } else {
      console.log('[capacityDrawerUI] .cart-drawer__dialog not found');
    }
  }

  // ── Action handlers ───────────────────────────────────────────

  function handleToggle(toSub, variantId, sellingPlan) {
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (toSub) body.items[0].selling_plan = sellingPlan;

    fetch('/cart/clear.js', { method: 'POST' })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add.js ' + r.status);
        return fetchCart();
      })
      .then(function (cart) {
        currentCart = cart;
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: null, data: {} },
        }));
      })
      .catch(function (e) {
        console.error('[capacityDrawerUI toggle]', e);
      });
  }

  function handleQtyChange(itemKey, newQty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: newQty }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        currentCart = cart;
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: null, data: {} },
        }));
      })
      .catch(function (e) {
        console.error('[capacityDrawerUI qty]', e);
      });
  }

  // ── Init ──────────────────────────────────────────────────────

  function setup() {
    console.log('init called');
    fetchCart().then(function (cart) { currentCart = cart; });
    setupObserver();

    document.addEventListener('cart:update', function (e) {
      if (e.detail && e.detail.resource) currentCart = e.detail.resource;
      setTimeout(function () {
        if (currentCart) renderAll(currentCart);
      }, 400);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  window.capacityDrawerUI = { renderAll: renderAll, fetchCart: fetchCart };
})();
